import { FC, ReactNode, useEffect } from 'react';
import { steps } from './SequenceSteps';
import useOnboardingKYCStore from 'stores/onboardingKYCStore';
import ProgressBar from './ProgressBar';

const OnboardingKYCSequence = () => {
  const { progressStep, setPercentCompleted, rotateVault } =
    useOnboardingKYCStore();

  useEffect(() => {
    setPercentCompleted(steps[progressStep].progressOnMount);
    rotateVault(50);
  }, [progressStep]);

  return (
    <div className="grid w-full h-full grid-rows-[1fr_auto] gap-[30px] pb-[30px]">
      {steps[progressStep].component}
      <div>
        <ProgressBar />
      </div>
    </div>
  );
};

export const SequenceItem: FC<{ children: ReactNode }> = ({ children }) => (
  <div className="grid w-full h-full grid-rows-[1fr_auto] gap-[30px]">
    {children}
  </div>
);

export default OnboardingKYCSequence;
